import { Injectable } from '@angular/core';
import { ConfigProvider } from "../../config-provider.service";
import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { ApiBaseService } from "../../common/providers/api-base-service";
import { LangsProvider } from "../../common/providers/langs-provider";
import { CurrentUser } from "../../common/providers/current-user";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { User, UserData } from "../../common/models/user";
import { UserLink } from "../../common/models/user-link";
import { UserUserLink } from "../../common/models/user-user-link";
import { Paginator } from "../../common/models/paginator";

@Injectable({
  providedIn: 'root'
})
export class UsersProvider {
  public readonly AVATAR_MAX_WIDTH: number = 7000;
  public readonly AVATAR_MAX_HEIGHT: number = 7000;
  public readonly AVATAR_MAX_SIZE: number = 5; // Mo
  public readonly AVATAR_ALLOWED_EXTENSIONS: string[] = ['jpg', 'jpeg', 'png'];
  constructor(
    private _conf: ConfigProvider,
    private _utils: UtilsProvider,
    private api: ApiBaseService,
    private _langs: LangsProvider,
    private _currentUser: CurrentUser
  ) {  }

  public get(organizationId:number, userId: number): Observable<User> {
    return this.api.call('get', `organizations/${organizationId}/users/${userId}`, {}, this._currentUser.getAccessToken())
      .pipe(
        map((data: User) => User.fromAPI(data))
      );
  }

  public getUsers(organizationId: number): Observable<User[]> {
    return this.api.call('get',`organizations/${organizationId}/users`, {}, this._currentUser.getAccessToken())
      .pipe(
        map((result: Paginator) => User.fromAPIList(result.data))
      );
  }

  public createUser(user: User): Observable<User> {
    return this.api.call('post',
      `users/0`,
      user.toJson(),
      this._currentUser.getAccessToken()
    ).pipe(
      map((data: any) => User.fromAPI(data.user))
    );
  }

  public updateUser(userId: number, data:any): Observable<User> {
    if (this._currentUser.user?.id == userId) {
      this._currentUser.invalidateCurrentUserCache();
    }
    return this.api.call(      'post',
      `users/${userId}`,
      data,
      this._currentUser.getAccessToken(),
      false
    ).pipe(
      map((data: any) => {
        return User.fromAPI(data.user)
      })
    );
  }


  /*** END NEW REQUESTS ***/
  /*** ****************************** ***/
  /*** ******************************************** ***/
  /*** ****************************** ***/
  /*** OLD REQUESTS ***/



  /* Deep checks if the user is created; otherwise, check whether the user has any relationships (e.g., coach, guest, etc.). */
  public checkEmailAvailability({email, deep = false}:{email: string, deep: boolean}): Observable<boolean> {
    return this.api.call('get',
      'users/email-availability',
      { email: email, deep: deep },
      this._currentUser.getAccessToken()
    ).pipe(
      map((result: any) => result.isAvailable),
    );
  }

  public sendInvitation(user: User): Observable<void> {
    return this.api.call('post', 'auth/resend-invitation', {
        email: user.email
      }, this._currentUser.getAccessToken()
    );
  }

  public changePassword(user: User, newPassword: string, currentPassword: string): Observable<void> {
    return this.api.call(            'post',
      'users/' + user.id + '/change-password',
      {
        newPassword,
        currentPassword
      },
      this._currentUser.getAccessToken()
    );
  }

  public changeEmail({newEmail} : {newEmail: string}) : Observable<void> {
    return this.api.call(
      'put', `email`,
      {
        "email": newEmail
      },
      this._currentUser.getAccessToken()
    );
  }

  public getUserUserLinksData(userId: number, addMissing = true): Observable<{userLink: UserLink, user_userLink: UserUserLink}[]> {
    return of([]);
    // NOT FULLY IMPLEMENTED
    // return this.api.call('get', 'users/' + userId + '/user-links',{}, this._currentUser.getAccessToken()).pipe(
    //   map((result: any) => {
    //     const data: any[] = [];
    //     for (let i = 0; i < result.userLinks.length; i++) {
    //       let user_userLink: UserUserLink = this._utils.findIn(result.userLinks[i].id, result.userUserLinks, 'userLinkId');
    //       if (!user_userLink && addMissing) {
    //         user_userLink = new UserUserLink({});
    //         user_userLink.userId = userId;
    //         user_userLink.userLinkId = result.userLinks[i].id;
    //       }
    //
    //       if (user_userLink || addMissing) {
    //         data.push({
    //           userLink: UserLink.fromAPI(result.userLinks[i], result.translationsData),
    //           user_userLink
    //         });
    //       }
    //     }
    //     return data;
    //   })
    // );
  }


}
